import React from 'react';
import Tooltip from 'sushiweb/Tooltip';

export const TooltipBox = ({
  label = '',
  title = '',
  labelWidth,
  border = true,
  position,
  titleColor = '#1C1C1C',
  fontWeight = '500',
  fontSize = 16,
  appearance = 'dark',
  widthMaxContent = true,
  noPadding = false,
  top,
  maskData = false,
}) => {
  if (!label) label = '';
  let bottomBorder = border && label ? 'greenBottomBorder' : '';
  let TooltipTemplate = (
    <Tooltip
      label={label}
      position={position}
      widthMaxContent={widthMaxContent}
      appearance={appearance}
      width={labelWidth}
      style={{
        padding: noPadding ? 0 : '1rem',
        borderWidth: noPadding ? 0 : '0.2rem',
        textAlign: 'left',
        top: top,
      }}
      data-dd-privacy='mask'
    >
      <span
        data-dd-privacy={maskData ? 'mask' : undefined}
        className={`${bottomBorder} flex center`}
        style={{
          color: titleColor,
          fontWeight: fontWeight,
          fontSize: fontSize,
        }}
      >
        {title}
      </span>
    </Tooltip>
  );
  return TooltipTemplate;
};
